import { render, staticRenderFns } from "./ServiceRequestHistoryUnit.vue?vue&type=template&id=061ffe7a&scoped=true"
import script from "./ServiceRequestHistoryUnit.vue?vue&type=script&lang=js"
export * from "./ServiceRequestHistoryUnit.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestHistoryUnit.vue?vue&type=style&index=0&id=061ffe7a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ffe7a",
  null
  
)

export default component.exports